import request from '@/utils/request'
import { menuCodeHeaders } from '@/utils/menuCodeHeaders'
import { GetOutboundsReq, GetOutboundSummaryReq, OutboundsItem, OutboundsMenuCode, OutboundSummaryItem } from '@/services/outbound/outboundSearch/types'

export const getOutboundSummary = (params: ApiPaginationReq<GetOutboundSummaryReq>) =>
  request.post<ApiResponseV2<ApiPageResponse<OutboundSummaryItem>>, ApiPaginationReq<GetOutboundSummaryReq>>(`/api/v1/get-outbound-summary`, params)

// 출고조회 API 는 gi25 와 gi24 하단 상세가 같이 부른다 — 감사 로그 화면코드를 헤더로 보낸다(LOGISPRD-15645)
export const getOutbounds = (params: ApiPaginationReq<GetOutboundsReq>, menuCode: OutboundsMenuCode) =>
  request.post<ApiResponseV2<ApiPageResponse<OutboundsItem>>, ApiPaginationReq<GetOutboundsReq>>(
    `/api/v1/get-outbounds`,
    params,
    menuCodeHeaders(menuCode),
  )

/**
 * 출고 취소 API
 * @param cutOffNo - 취소할 것으로 번호 (예: 202501I915_MUSINSA_00000001)
 * @see https://api-gw-dev.oms.musinsalogistics.co.kr/swagger-ui/index.html#/outbound-controller/cancelCutoff
 */
export const cancelOutboundCutoff = (cutOffNo: string) =>
  request.post<ApiResponseV2<null>>(`/api/v1/outbound/cutoff/${cutOffNo}/cancel`, {})
